import { useStore as t } from "@nanostores/react";
import { useState as l, useCallback as a, useEffect as c } from "react";
import { atom as f } from "nanostores";
import { CopilotSession as n } from "../session.js";
import { currentCopilotSession as r } from "../global-state.js";
const m = f(null);
function g(e) {
  const [s, u] = l(() => new n()), i = a(() => {
    const o = new n();
    return u(o), o;
  }, []);
  return c(() => {
    e?.isPrimary && r.set(s);
  }, [s, e?.isPrimary]), s.reset == null && Object.assign(s, { reset: i }), s;
}
function M() {
  return t(r);
}
function w(e) {
  return t(e?.__status ?? m);
}
function y(e) {
  return t(e.__statefulMessages);
}
function P(e) {
  return t(e.__tools);
}
function d(e) {
  return t(e.__meta);
}
function h(e) {
  return t(e.__queuedMessages);
}
function W(e) {
  return t(e.__enableWebSearch);
}
export {
  P as useCopilotAvailableTools,
  y as useCopilotMessages,
  d as useCopilotMeta,
  h as useCopilotQueuedMessages,
  g as useCopilotSession,
  w as useCopilotStatus,
  W as useCopilotWebSearch,
  M as usePrimaryCopilotSession
};
